import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-exit-dialog',
  templateUrl: './confirm-exit-dialog.component.html',
  styleUrl: './confirm-exit-dialog.component.scss'
})
export class ConfirmExitDialogComponent {
  constructor(private dialogRef: MatDialogRef<ConfirmExitDialogComponent>) {}

  onClose() {
    this.dialogRef.close(null); // Stays on page
  }

  onExitWithoutSaving() {
    this.dialogRef.close(false); // Exits without saving (Yes)
  }

  onSaveAndExit() {
    this.dialogRef.close(true); // Saves and exits
  }
}
